// Hide DOM elements by Class Name
export const showHideElementsByClassName = (action, className, displayStyle = "inline-block") => {
  let elems = document.getElementsByClassName(className);
  if (elems && elems.length) {
    let display = "none";
    if (action === "show") display = displayStyle;
    let elemsLen = elems.length;
    for (let i = 0; i < elemsLen; i++) {
      elems[i].style.display = display;
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/managers/dom.js